import { Pipe, PipeTransform } from '@angular/core';
import { temperatureUtil } from 'src/app/util/temperature-util';
import { UserDataService } from 'src/app/util/user-data.service';

@Pipe({
  name: 'formatTemperature',
})
export class TemperatureFormatPipe implements PipeTransform {
  constructor(private userDataService?: UserDataService) {}

  transform(temperature?: number, round?: boolean): string {
    if (!temperature) {
      return '';
    }

    const localeUnit = temperatureUtil.GetUnit(
      'text',
      this.userDataService?.user?.preferences
    );

    const convertedTemperature =
      localeUnit === 'fahrenheit'
        ? temperatureUtil.ConvertTemperature(temperature, 'fahrenheit')
        : temperature;

    const formatValue = () =>
      round ? Math.round(convertedTemperature) : convertedTemperature;

    return new Intl.NumberFormat([], {
      localeMatcher: 'best fit',
      style: 'unit',
      unit: localeUnit,
    }).format(formatValue());
  }
}
